module.exports = __webpack_public_path__ + "static/img/logo_light.69389830.png";